import classNames from 'classnames'

import './DisplayLabel.scss'

export interface DisplayLabelProps {
  label?: string
  variant?: 'primary' | 'paragraph'
}

export const DisplayLabel: React.FC<DisplayLabelProps> = ({
  label,
  variant = 'primary',
}) => {
  return <div className={classNames('display-label', variant)}>{label}</div>
}
